export default {
  selectedDateState: state => state.selectedDate
}
